var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"more-loading-wrapper"},[_c('img',{attrs:{"src":"https://files.wondercv.com/icon/loading.gif"}}),_c('span',[_vm._v("正在加载")])])}]

export { render, staticRenderFns }